import { GreekResponseStringsMap, StatsStringsMap } from "./legs.strings";

export const minValue = 1
export const maxValue = 99999
export const step = 1

export const IndexScripMap = {
  'NIFTY': 'Nifty50',
  'BANKNIFTY': 'NiftyBank',
  'FINNIFTY': 'NiftyFinService',
  'MIDCPNIFTY': 'NIFTYMIDSELECT',
  "SENSEX": "SENSEX"
};

export let IndexScripMapRev;
(function (reverseInst) {
  reverseInst[reverseInst['NIFTY'] = 'Nifty50'] = 'NIFTY';
  reverseInst[reverseInst['BANKNIFTY'] = 'NiftyBank'] = 'BANKNIFTY';
  reverseInst[reverseInst['FINNIFTY'] = 'NiftyFinService'] = 'FINNIFTY';
  reverseInst[reverseInst['MIDCPNIFTY'] = 'NIFTYMIDSELECT'] = 'MIDCPNIFTY';
})(IndexScripMapRev || (IndexScripMapRev = {}));



// Time after which data should auto-refresh for legs (milliseconds);
export const AutoRefreshTime = 45 * 1000;

export const GreekResponseStruct =
  [
    {
      title: 'Delta',
      value: 0,
      icon: 'info',
      precision: 4,
      desc: GreekResponseStringsMap.delta,
      top: 170
    },
    {
      title: 'Theta',
      value: 0,
      icon: 'info',
      precision: 4,
      desc: GreekResponseStringsMap.theta,
      top: 190
    },
    {
      title: 'Rho',
      value: 0,
      icon: 'info',
      precision: 4,
      desc: GreekResponseStringsMap.rho,
      top: 85
    },
    {
      title: 'Gamma',
      value: 0,
      icon: 'info',
      precision: 5,
      desc: GreekResponseStringsMap.gamma,
      top: 130
    },
    {
      title: 'Vega',
      value: 0,
      icon: 'info',
      precision: 4,
      desc: GreekResponseStringsMap.vega,
      top: 170
    }
  ];

export const exchangeTimeObj = {
  'hour': 15,
  'minute': 30, 'second': 0
}

export const StatsStruct = [
  {
    title: 'Max Profit',
    value: 0,
    isColored: true,
    isInfoPresent: false,
    desc: StatsStringsMap.maxProfit
  },
  {
    title: 'Max Loss',
    value: 0,
    isColored: true,
    isInfoPresent: true,
    desc: StatsStringsMap.maxLoss
  },
  {
    title: 'Risk/Reward',
    value: 0,
    isColored: false,
    isInfoPresent: false,
    desc: StatsStringsMap.riskReward
  },
  {
    title: 'Break Even',
    value: '0',
    isColored: false,
    isInfoPresent: true,
    desc: StatsStringsMap.breakEven
  },
  // Hiding payoff pending calculations
  //   {
  //     title: 'POP',
  //     value: '0',
  //     isColored: false,
  //     isInfoPresent: true,
  //   },
  //   {
  //     title: 'Projected Return',
  //     value: 0,
  //     isColored: false,
  //     isInfoPresent: false,
  //   },
  //   {
  //     title: 'Funds Needed',
  //     value: 0,
  //     isColored: false,
  //     isInfoPresent: false,
  //   },
  {
    title: 'Margin Needed',
    value: 0,
    isColored: false,
    isInfoPresent: false,
    desc: StatsStringsMap.marginNeeded
  }
]

export const PayOffDefaultData = {
  'Break Even': 0,
  'Funds Needed': 0,
  'Margin Needed': 0,
  'Max Loss': '',
  'Max Profit': '',
  'POP': 0,
  'percentage_deviation': 0,
  'Projected Return': 0,
  'Risk/Reward': '',
  'payOffCurveExpiry': [],
  'payOffCurveTarget': [],
  'standard_deviation': 0
};


export const IndexScripMapIndicator = {
  'NIFTY': 'Nifty50',
  'BANKNIFTY': 'NiftyBank',
  'FINNIFTY': 'NiftyFinService',
  'MIDCPNIFTY': 'NIFTYMIDSELECT',
  "SENSEX": "SENSEX",
  "Nifty50": "Nifty50"
};

export enum DynamicSymbolType {
  SELECT_REFERENCE_SYMBOL = "0",
  CREATE_REFERENCE_SYMBOL = "1"
}